<template>
  <div class="live-list">
    <swiper class="center-content" :options="swiperOption">
      <template v-for="item in resList">
        <swiper-slide :key="item.name">
          <div class="live-list-item">
            <div class="live-list-item-cover">
              <img :src="item.cover + '?imageMogr2/thumbnail/184x90'" />
            </div>
            <div class="live-list-item-title">
              {{item.name}}
            </div>
            <div :class="getStatusStyle(item.status)">
              {{ getStatusStr(item.status) }}
            </div>
            <div class="live-list-item-count">
              直播时长: <span class="live-list-item-count-num">{{item.runTimeHours}}时{{item.runTimeMins}}分</span>
            </div>
            <div class="live-list-item-count">
              观看学员: <span class="live-list-item-count-num">{{item.studentCount}}人</span>
            </div>
            <div class="live-list-item-count">
              观看次数: <span class="live-list-item-count-num">{{item.viewCount}}次</span>
            </div>
          </div>
        </swiper-slide>
      </template>
    </swiper>
  </div>
</template>

<script>
import { getLiveApi } from '@/api/school'
export default {
  name: 'SubLive',
  data () {
    return {
      swiperOption: {
        loop: true,
        autoplay: true,
        slidesPerView: 2,
        spaceBetween: 10
      },
      resList: []
    }
  },
  props: {
    schoolId: Number
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getLiveApi({ schoolId: this.schoolId }).then(res => {
        this.resList = res.result
        setTimeout(this.getData, 60000)
      })
    },
    getStatusStr (status) {
      if (status === 'UNLIVE') {
        return '未开播'
      } else if (status === 'LIVING') {
        return '直播中'
      } else if (status === 'ENDLIVE') {
        return '直播结束'
      } else {
        return '未开播'
      }
    },
    getStatusStyle (status) {
      if (status === 'UNLIVE') {
        return 'live-list-item-unlive'
      } else if (status === 'LIVING') {
        return 'live-list-item-living'
      } else if (status === 'ENDLIVE') {
        return 'live-list-item-lived'
      } else {
        return 'live-list-item-unlive'
      }
    }
  }
}
</script>

<style lang="less">

.live-list {
  width: 100%;
  height: 96%;
  display: flex;
  margin-top: 4%;
  padding: 0 10px;
  box-sizing: border-box;
}

.live-list-item {
  width: 100%;
  height: 100%;
}

// .live-list-item-cover {

// }

.live-list-item-cover img{
    width: 100%;
    height: 90px;
    border-radius: 5px;
  }

  .live-list-item-title
  {
    width: 90%;
    height: 30px;
    font-size: 16px;
    line-height: 30px;
    overflow: hidden;
    text-overflow:ellipsis;
    margin-top: 10px;
    white-space: nowrap;
  }

.live-list-item-unlive {
  color: #4d99fc;
  font-size: 15px;
  font-style: oblique;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

.live-list-item-living {
  color: #f46827;
  font-size: 15px;
  font-style: oblique;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

.live-list-item-lived {
  color: #40faee;
  font-size: 15px;
  font-style: oblique;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

.live-list-item-count {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}

.live-list-item-count-num {
  color: #f46827;
  font-weight: bold;
}

</style>
